import { type AppThunk } from 'services/redux/configureStore';

import { tasksBoardApi } from '../../api/tasksBoardApi';
import { updateTask } from '../slices/tasks/tasksSlice';

export const readAllTasksThunk =
  (): AppThunk<Promise<{ success: boolean }>> => async (dispatch, getState) => {
    const allTasks = Object.keys(getState().tasksBoard.tasks.byId);

    try {
      const response = await dispatch(tasksBoardApi.endpoints.readAllBoardTasks.initiate()).unwrap();

      if (response.success) {
        // Оставляем только те задачи, которые на бэке вернулись как прочитанные в результате запроса
        const filteredTasks = allTasks.filter((id) => response.data.ids.includes(Number(id)));

        for (const id of filteredTasks) {
          dispatch(updateTask({ id: Number(id), patch: { isViewed: true } }));
        }
        return { success: true };
      } else {
        return { success: false };
      }
    } catch (e) {
      return { success: false };
    }
  };
